<template>
    <div class="option-switch">
        <div class="os-label">
            <span v-html="config.longLabel ? config.longLabel : config.label"></span>
            <template v-if="config.supplementary">
                <small class="supplementary" v-html="config.supplementary"></small>
            </template>
        </div>
        <label class="switch mb-0">
            <input class="checkbox" type="checkbox" :checked="value" @change="didChangeSwitch($event)">
            <span class="runner"></span>
            <span class="dot"></span>
        </label>
    </div>
</template>

<script>
    export default {
        name: 'OptionSwitch',
        props: {
            value: {
                type: Boolean,
                default: false,
            },
            config: {
                type: Object,
                default() {
                    return {
                        label: 'Switch',
                    };
                },
            },
        },
        methods: {
            didChangeSwitch(event) {
                this.$emit('input', event.target.checked);
            },
        },
    };

</script>
